export default {
  ticket_created_successfully: 'Solicitud creada con exito.',
  success_message: '¡Tu Ticket se ha ingresado con éxito!',
  ticketNumber: 'Número de incidencia',
  your_ticket: 'Su solicitud número ',
  has_been_entered: ' ha sido ingresada y le hemos enviado un correo de confirmación con el número y tiempo de resolución.',
  txt_subtitle1: '¿Qué puedes hacer ahora?',
  txt_subtitle2: 'Consultar el estado de tu solicitud, ver las respuesta del equipo de soporte y generar nuevos tickets.',
  btn_tickets: 'Ir a mis tickets'

}
